import React from 'react';
import { PiggyBank, BarChart2 } from 'lucide-react';

const EarlyRepaymentSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  earlyRepaymentPeriods 
}) => {
  if (!formData.includeEarlyRepayment) return null;

  // Получение символа валюты
  const getCurrencySymbol = () => {
    switch (formData.currency) {
      case 'USD': return '$';
      case 'EUR': return '€';
      case 'GBP': return '£';
      case 'CHF': return 'Fr';
      case 'JPY': case 'CNY': return '¥';
      default: return formData.currency;
    }
  };

  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <PiggyBank className="w-5 h-5 mr-2 text-green-500" />
        Досрочное погашение
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Сумма досрочного погашения */}
        <div>
          <label htmlFor="earlyRepaymentAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Сумма досрочного платежа ({formData.currency})
          </label>
          <div className="relative mt-1">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <span className="text-gray-500 sm:text-sm">{getCurrencySymbol()}</span>
            </div>
            <input
              type="text"
              id="earlyRepaymentAmount"
              name="earlyRepaymentAmount"
              value={formData.earlyRepaymentAmount}
              onChange={handleInputChange}
              className={`form-input pl-7 w-full ${errors.earlyRepaymentAmount ? 'input-error' : ''}`}
              placeholder="Введите сумму"
            />
          </div>
          {errors.earlyRepaymentAmount && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.earlyRepaymentAmount}
            </p>
          )}
        </div>

        {/* Период досрочного погашения */}
        <div>
          <label htmlFor="earlyRepaymentPeriod" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Периодичность
          </label>
          <select
            id="earlyRepaymentPeriod"
            name="earlyRepaymentPeriod"
            value={formData.earlyRepaymentPeriod}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.earlyRepaymentPeriod ? 'input-error' : ''}`}
          >
            {earlyRepaymentPeriods.map((period) => (
              <option key={period.id} value={period.id}>
                {period.name}
              </option>
            ))}
          </select>
          {errors.earlyRepaymentPeriod && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.earlyRepaymentPeriod}
            </p>
          )}
        </div>

        {/* Месяц начала досрочного погашения */}
        <div>
          <label htmlFor="earlyRepaymentStartMonth" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Начать с месяца
          </label>
          <input
            type="text"
            id="earlyRepaymentStartMonth"
            name="earlyRepaymentStartMonth"
            value={formData.earlyRepaymentStartMonth}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.earlyRepaymentStartMonth ? 'input-error' : ''}`}
            placeholder="Номер месяца"
          />
          {errors.earlyRepaymentStartMonth && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.earlyRepaymentStartMonth}
            </p>
          )}
        </div>

        {/* Тип досрочного погашения */}
        <div className="col-span-full">
          <div className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Цель досрочного погашения
          </div>
          <div className="grid grid-cols-2 gap-2">
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="earlyRepaymentType"
                value="reduction"
                checked={formData.earlyRepaymentType === 'reduction'}
                onChange={handleInputChange}
                className="form-radio"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                Уменьшение срока
              </span>
            </label>
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="earlyRepaymentType"
                value="payment"
                checked={formData.earlyRepaymentType === 'payment'}
                onChange={handleInputChange}
                className="form-radio"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                Уменьшение платежа
              </span>
            </label>
          </div>
          {errors.earlyRepaymentType && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.earlyRepaymentType}
            </p>
          )}
        </div>
      </div>
      
      <div className="mt-4 bg-green-100 dark:bg-green-900/30 p-3 rounded-lg border border-green-200 dark:border-green-800">
        <div className="flex items-start">
          <BarChart2 className="w-5 h-5 text-green-600 dark:text-green-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-green-700 dark:text-green-300 mb-1">
              Совет по досрочному погашению валютной ипотеки
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400">
              При валютной ипотеке досрочное погашение особенно выгодно в периоды укрепления рубля. 
              Рассмотрите возможность конвертации рублевых накоплений в валюту кредита в такие периоды для максимальной выгоды.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EarlyRepaymentSection;